import { getApi, postApi, putApi} from "../api";
import { encryptdata } from "../../../utils/encryptDecrypt";


export const createSubscriptionApi = (data)=> postApi(`masters/subscription/create`, data)
export const viewSubscriptionApi = ()=> getApi(`masters/subscription/all`)
export const updateSubscriptionApi = (id, data)=> putApi(`masters/subscription/update/${encryptdata(id)}`, data)
